import { render } from "./App.vue?vue&type=template&id=9d4d6630"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9d4d6630&lang=scss"

import exportComponent from "/mnt/data/dev.bl8m.it/vhosts/clients/client0/web144/web/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__